/* Vialex storefront — light motion layer.
   Declarative scroll-reveals ([data-anim]) + a sequenced hero entrance, built on
   GSAP + ScrollTrigger. Motion is gated on prefers-reduced-motion via
   gsap.matchMedia; the <head> guard + failsafe in layout/theme.liquid guarantee
   content is never left hidden if this library fails to load.

   Reveal vocabulary (kept deliberately small — "leve"):
     data-anim="fade-up"  → fade in + rise 24px (the workhorse)
     data-anim="fade"     → fade in only (no transform)
   Every reveal clears its transform on completion, so nothing lingers to break a
   sticky column or a stacking context. */
(function () {
  // Library missing (blocked / 404): the <head> failsafe reveals content; bail.
  if (!window.gsap || !window.ScrollTrigger) return;

  // We're live — cancel the "reveal anyway" failsafe set in the <head>.
  if (window.__vlxAnimFailsafe) {
    clearTimeout(window.__vlxAnimFailsafe);
    window.__vlxAnimFailsafe = null;
  }

  gsap.registerPlugin(ScrollTrigger);

  var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reveal every [data-anim] inside `scope` on demand. For markup that appears
  // after the initial scan — a tab switch (hidden panel) or async product
  // recommendations — so those items never stay hidden.
  window.vlxReveal = function (scope) {
    if (!scope) return;
    var items = scope.querySelectorAll('[data-anim]');
    if (!items.length) return;
    if (prefersReduce) { gsap.set(items, { autoAlpha: 1, clearProps: 'transform' }); return; }
    gsap.fromTo(items, { y: 24 }, {
      autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.06, ease: 'power2.out',
      overwrite: true, clearProps: 'transform'
    });
  };

  gsap.matchMedia().add('(prefers-reduced-motion: no-preference)', function () {
    // Pre-reveal rise (opacity/visibility already handled by animations.css).
    gsap.set('[data-anim="fade-up"]', { y: 24 });

    // Hero: sequenced entrance on load (above the fold — no scroll trigger).
    // Copy elements cascade, then the showcase fades in as one unit; its inner
    // [data-hero-track] scroll-snap stays owned by hero-carousel.js.
    var heroItems = gsap.utils.toArray('.vlx-hero [data-anim]');
    if (heroItems.length) {
      gsap.timeline({ defaults: { ease: 'power2.out', duration: 0.6 } })
        .to(heroItems, { autoAlpha: 1, y: 0, stagger: 0.08, clearProps: 'transform' }, 0.1);
    }

    // Everything else: reveal once on scroll; co-entering siblings cascade.
    var scrollItems = gsap.utils.toArray('[data-anim]').filter(function (el) {
      return !el.closest('.vlx-hero');
    });
    if (scrollItems.length) {
      ScrollTrigger.batch(scrollItems, {
        start: 'top 85%',
        once: true,
        onEnter: function (batch) {
          gsap.to(batch, {
            autoAlpha: 1, y: 0, duration: 0.6, stagger: 0.08, ease: 'power2.out',
            overwrite: true, clearProps: 'transform'
          });
        }
      });
    }

    // Recompute trigger positions once images/fonts have settled.
    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  });
})();
